import React, { useState } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { showModal } from '../../actions/modalActions';

import { MODAL_TYPE_NOTIFICATION } from '../../constants/modalTypes';

import TermsOfUse from '../legal/termsOfUse'

import './footer.css'

import {
	Col,
	Row,
} from 'reactstrap';
import { useAppDispatch } from '../../store';

const Footer: React.FC<any> = (props) => {

	const [year] = useState(new Date().getFullYear());
	const dispatch = useAppDispatch();

	const showTermsOfUse = (event: any) => {
		event.preventDefault();
		dispatch(showModal(MODAL_TYPE_NOTIFICATION, {
			title: 'Terms of Use',
			children: <TermsOfUse />,
			contentClassName: 'scrollable',
			size: 'lg',
		}));
	};

	let headerFooterFont = props.fontColor ? props.fontColor : '#FFFFFF';
	return (
		<Row className="footer2">
			<Col className="text-center">
				<span style={{ color: headerFooterFont }}>© {year} <a style={{ color: headerFooterFont }} href="http://www.myhealthdirect.com">Experian Health. All Rights Reserved.</a></span>
				{false &&
					<React.Fragment>
						<span className="nh-seperator">|</span>
						<Link to="/terms-of-use" onClick={showTermsOfUse} style={{ color: headerFooterFont }} className="nh-terms-of-service">Terms of Use</Link>
					</React.Fragment>
				}
			</Col>
		</Row>
	)
}

export default Footer;
